import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const InfoBullets: FC = () => {
  const { t } = useTranslation('input');

  return (
    <ul >
      <li>{t('form.info_1.bullet_1')}</li>
      <li>{t('form.info_1.bullet_2')}</li>
      <li>{t('form.info_1.bullet_3')}</li>
      <li>{t('form.info_1.bullet_4')}</li>
      <li>{t('form.info_1.bullet_5')}</li>
    </ul>
  );
};